import produce from "immer"
import { OkrMetric } from "server/models"
import { InferValueTypes } from "client/utils"
import * as types from "./types"
import * as actions from "./actions"

type ActionTypes = ReturnType<InferValueTypes<typeof actions>>

export const initOkrMetric: OkrMetric = {
    id: null,
    accountId: null,
    name: "",
    symbol: "",
    displayAfter: false,
    creator: null,
}

const initOkrMetricState: types.OkrMetricState = {
    metricList: {},
    metricIds: [],
    metricEdit: initOkrMetric,

    reloadList: true,
    reloadEdit: true,
}

const okrMetricReducer = produce((
    draft: types.OkrMetricState = initOkrMetricState,
    action: ActionTypes = null,
): types.OkrMetricState => {
    switch (action.type) {
        case types.OKR_METRIC_LIST:
            draft.metricList = action.metricList
            return draft

        case types.OKR_METRIC_IDS:
            draft.metricIds = action.metricIds
            return draft

        case types.OKR_METRIC_EDIT:
            draft.metricEdit = action.value
            return draft

        case types.OKR_METRIC_RELOAD_LIST:
            draft.reloadList = action.value
            return draft

        case types.OKR_METRIC_RELOAD_EDIT:
            draft.reloadEdit = action.value
            return draft

        default:
            return draft
    }
})
export default okrMetricReducer
